import React from 'react';
import GlobalHeader from '../../Fragments/GlobalHeader';

let Quote       = require('../../Managers/Quote');
let QuoteError = require('../../Managers/QuoteError');

const QuoteReferred = React.createClass({
    getInitialState() {
        return {
            reasons: null,
            quoteId: null,
            userTitle: Quote.getCurrentAnswer('title'),
            userLastName: Quote.getCurrentAnswer('last_name'),
        };
    },
    componentWillMount() {
        let e = QuoteError.get();
        this.setState({
            reasons: e.displayError,
            quoteId: e.quoteNumber
        });
    },
    componentDidMount() {
        window.scrollTo(0, 0);
        // Quote has referred. We have the values we use on this page in state,
        // so clear the questions cache and answers array.
        onbeforeunload();
    },
    render() {
        return (
            <div>
                <GlobalHeader />

                <div className="container stepless" />
                <question-row class="no-border unpadded">
                    <div className="question-main">
                        <h1>We&rsquo;ll be in touch shortly</h1>
                        {this.state.userTitle ?
                        <p><b>{this.state.userTitle} {this.state.userLastName}, your quote has now been referred to our Insurance team</b></p>
                        :
                        <p><b>Your quote has now been referred to our Insurance team</b></p>}
                        <p>Thank you for choosing HomeLet to get a landlord insurance quote. The details that you've entered have been passed to our Insurance team. We&rsquo;ll contact you within 24 hours to gather some additional information from you and complete your quotation.</p>
                        <p>Alternatively, you can call our Insurance team on <strong>0800 038 4574</strong>, quoting your reference number, which is {this.state.quoteId}.</p>
                        <p>Our lines are open:<br />
                            Monday to Friday from 8:30am - 6:30pm<br />
                            Saturday 9:30am - 1pm</p>
                        <p>We appreciate your patience and want to help you to arrange your cover as quickly as possible. In the meantime, here&rsquo;s want some of our customers said about our specialist landlords&rsquo; insurance cover:</p>
                        <div className="referral-promo">
                            <div className="left">
                                <img src="/images/trusted-merchant.png" alt="2016 Feefo Trusted Merchant" />
                            </div>

                            <div className="right">
                                <blockquote>"Insurance product was great and affordable. Customer service was excellent and explained everything clearly"</blockquote>
                                <blockquote>"Exactly fits my requirement at a most affordable and highly competitive price"</blockquote>
                                <a className="underline" href="http://ww2.feefo.com/en-gb/reviews/homelet?withMedia=false&timeFrame=YEAR&displayFeedbackType=PRODUCT&productline-tags=Landlord%20Insurance">Read more customer reviews</a>
                            </div>
                        </div>
                        <p>We look forward to talking to you.</p>
                        <p>Kind regards,</p>
                        <p>The HomeLet Team</p>
                    </div>
                </question-row>
            </div>
        );
    }
});

export default QuoteReferred;



/** WEBPACK FOOTER **
 ** ./src/components/Screens/Quote/QuoteReferred.js
 **/